import * as React from 'react';
import { Text } from '@quality24/design-system';

import LoginForm, {
  LoginFormValues,
} from '../../components/organisms/LoginForm';
import { IsFederatedUserPayload } from '../../contexts/auth/authContext';

export interface Props {
  isFirstAccess: boolean;
  inProgress: boolean;
  initialValues: LoginFormValues;
  onLogin: (values: LoginFormValues) => Promise<void>;
  onUpdatePassword: (username: string | undefined) => void;
  onSubmitEmail?: (value: string, callback?: () => void) => void;
  userFederations: IsFederatedUserPayload[] | null;
}

const SignInSection: React.FunctionComponent<Props> = ({
  isFirstAccess,
  initialValues,
  inProgress,
  onLogin,
  onUpdatePassword,
  onSubmitEmail,
  userFederations,
}) => (
  <>
    <Text weight="light">
      Seja <strong>bem-vindo</strong>. Faça o login para acessar sua conta
    </Text>

    {isFirstAccess && (
      <Text weight="light" className="mt-2">
        Se este é seu <strong>primeiro acesso</strong>, coloque a senha
        temporária que você recebeu em seu email
      </Text>
    )}

    <LoginForm
      className="mt-3"
      initialValues={initialValues}
      loading={inProgress}
      onSubmit={onLogin}
      onUpdatePassword={onUpdatePassword}
      onSubmitEmail={onSubmitEmail}
      userFederations={userFederations}
    />
  </>
);

export default SignInSection;
